import React from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Select, MenuItem, FormControl, InputLabel, Tooltip,
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupIcon from '@mui/icons-material/Group'; // MODIFICATION: Import GroupIcon
import { useNavigate } from 'react-router-dom';

const Navbar = ({ currentUser, allUsers = [], onImpersonate, onLogout }) => {
  const navigate = useNavigate();

  if (!currentUser) {
    return (
      <AppBar position="fixed">
        <Toolbar>
          <BusinessIcon sx={{ mr: 2 }} />
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>Card Vision</Typography>
        </Toolbar>
      </AppBar>
    );
  }

  return (
    <AppBar position="sticky" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <BusinessIcon sx={{ mr: 2 }} />
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600, cursor: 'pointer' }} onClick={() => navigate('/scanner')}>Card Vision</Typography>
        <Typography variant="body2" sx={{ mr: 3 }}>
          Logged in as: <strong>{currentUser.username}</strong>
        </Typography>

        {currentUser.is_super_admin && !currentUser.original_user_id && (
          <FormControl size="small" sx={{ m: 1, minWidth: 180, mr: 2 }} variant="outlined">
            <InputLabel id="impersonate-select-label" sx={{ color: 'white' }}>View User</InputLabel>
            <Select
              labelId="impersonate-select-label"
              value=""
              label="View User"
              onChange={(e) => onImpersonate(e.target.value)}
              sx={{
                color: 'white',
                '.MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                '.MuiSvgIcon-root': { color: 'white' },
              }}
            >
              {allUsers.map((user) => (
                <MenuItem key={user.id} value={user.id}>
                  {user.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {currentUser.is_super_admin && (
          <Tooltip title="Create New User">
            <IconButton color="inherit" onClick={() => navigate('/create-user')}>
              <PersonAddIcon />
            </IconButton>
          </Tooltip>
        )}
        
        {/* MODIFICATION START: Add Team Management Button */}
        <Tooltip title="Team Management">
          <IconButton color="inherit" onClick={() => navigate('/team')}>
            <GroupIcon />
          </IconButton>
        </Tooltip>
        {/* MODIFICATION END */}
        
        <Tooltip title="Logout">
          <IconButton color="inherit" onClick={onLogout}>
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;